import React from 'react';
import { useUiTheme } from '@/hooks/useUiTheme';

/** Renders the classic or the new (bento) version of a page, per the admin-selected interface theme. */
export const ByUiTheme: React.FC<{ bento: React.ReactNode; classic: React.ReactNode }> = ({ bento, classic }) => (
  <>{useUiTheme() === 'classic' ? classic : bento}</>
);
